import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

const CustomCheckboxContainer = styled.div`
  display: inline-block;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-focus-ring-color: rgba(0, 0, 0, 0);
`;

const CustomCheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Checkbox = styled.input`
  display: none;
`;

const Tick = styled.div`
  &:before {
    content: '\\00d7';
  }
  font-weight: bold;
  font-size: calc(${({ size }) => size} - 10px);
`;

const NoTick = styled.div`
  &:before {
    content: '';
  }
  height: 100%;
`;

const TickWrapper = styled.label`
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  cursor: ${({ pointerCursor }) => (pointerCursor ? 'pointer' : 'unset')};
  padding: ${({ padding }) => padding};
  background: ${({ background }) => background};
  color: ${({ color }) => color};
  text-align: center;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-focus-ring-color: rgba(0, 0, 0, 0);
`;

const CustomLabel = styled.div`
  padding-right: 20px;
  font-size: inherit;
`;

const CustomCheckbox = props => (
  <CustomCheckboxContainer onClick={() => props.onChange(!props.checked)}>
    <CustomCheckboxWrapper>
      <Checkbox checked={props.checked} id={props.name} readOnly />
      <CustomLabel htmlFor={props.name}>{props.label}</CustomLabel>
      <TickWrapper {...props}>{props.checked ? <Tick {...props} /> : <NoTick />}</TickWrapper>
    </CustomCheckboxWrapper>
  </CustomCheckboxContainer>
);

CustomCheckbox.defaultProps = {
  padding: '',
  label: '',
  pointerCursor: false,
  size: '50px',
  background: '#f8ecdc',
  color: '#000',
};

CustomCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  padding: PropTypes.string,
  pointerCursor: PropTypes.bool,
  size: PropTypes.string,
  background: PropTypes.string,
  color: PropTypes.string,
};

export default CustomCheckbox;
